<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<section id="wrapper" class="login-register login-sidebar" style="background-image:url(assets/images/background/login-register.jpg);">
    <div class="login-box card">
        <div class="card-body">


            <form ngNativeValidate [formGroup]="forma" (ngSubmit)="updatePassword()" class="form-horizontal form-material" id="loginform" action="index.html">

                <a href="javascript:void(0)" class="text-center db"><img src="assets/images/logo-icon.png" alt="Home" /><br/><img src="assets/images/logo-text.png" alt="Home" /></a>
                <br>

                <h5 class="card-title text-blue">Por favor ingresa un password para activar tu cuenta.</h5>

                <div class="form-group ">
                    <div class="col-xs-12">
                        <input formControlName="password" name="password" class="form-control" type="password" required placeholder="Contraseña">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-xs-12">
                        <input formControlName="password2" name="password2" class="form-control" type="password" required placeholder="Confirma contraseña">
                    </div>
                </div>

                <!-- <div class="form-group" *ngIf="forma.errors?.sonIguales && !forma.pristine">
                    <p class="text-danger">
                        Las contraseñas deben de se iguales
                    </p>
                </div>-->



                <div class="form-group text-center m-t-20">
                    <div class="col-xs-12">
                        <button [disabled]="loadRegister" class="btn btn-info btn-lg btn-block text-uppercase " type="submit">
                                <span [hidden]="!loadRegister" ><i class="fa fa-spin fa-spinner"></i></span>{{textoRegistrar}}
                            </button>
                    </div>
                </div>

                <div class="form-group m-b-0">
                    <div class="col-sm-12 text-center">
                        <p>¿Tienes una cuenta? <a routerLink="/login" class="text-info m-l-5"><b>Ingresa ahora</b></a></p>
                    </div>
                </div>
            </form>

        </div>
    </div>
</section>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->